export type GoogleTagIdKind = 'gtm' | 'ga4' | 'unknown';

export interface ClassifiedGoogleTagId {
  readonly kind: GoogleTagIdKind;
  readonly id: string;
}

const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/i;
const GA4_ID_PATTERN = /^G-[A-Z0-9]+$/i;

export function classifyGoogleTagId(
  value?: string | null,
): ClassifiedGoogleTagId | null {
  const id = value?.trim();
  if (!id) return null;

  if (GTM_ID_PATTERN.test(id)) return { kind: 'gtm', id };
  if (GA4_ID_PATTERN.test(id)) return { kind: 'ga4', id };

  return { kind: 'unknown', id };
}

export function isValidGoogleTagId(value?: string | null): boolean {
  const classified = classifyGoogleTagId(value);
  return classified === null || classified.kind !== 'unknown';
}

export function normalizeGoogleTagId(
  value?: string | null,
): string | undefined {
  const id = value?.trim();
  return id ? id : undefined;
}
